/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 11/17/14
 * Time: 2:29 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var _ = require("underscore");
    var AbstractAppender = require("notificationCenter/appenders/AbstractAppender");
    var TopBarNotificationController = require("controllers/userBarWidgets/TopBarNotificationController");
    var CONST = require("const");

    var TopBarNotification = AbstractAppender.extend({
        SETTINGS: {
            MAX_NOTIFICATIONS: 1,
            DISPLAY_WHEN_EMPTY: false
        },

        defaultOptions: {
            removeOnClose: true
        },

        initialize: function (options) {
            AbstractAppender.prototype.initialize.call(this, options);

            if (!this.isSupported()) {
                return;
            }
            this.LE = options.application;
            this.logger = this.LE.logger;
            this._setSettings(options);
            this.notificationCounter = 0;
            this._setTopBarNotificationController();
        },
        isEnabled: function () {
            return true;
        },
        isSupported: function () {
            return true;
        },
        getDefaultOptions: function () {
            return _.cloneDeep(this.defaultOptions);
        },
        notify: function (options) {
            this.logger.info("TopBarNotification::notify options: " + JSON.stringify(options));

            var id = this.getNotificationId();

            this.LE.vent.trigger("topBarNotificationController:newNotification", {
                id: id,
                type: options.type,
                contentOptions: options.contentOptions,
                viewOptions: options.viewOptions,
                onShow: options.onShow,
                onClose: options.onClose,
                removeOnClose: options.removeOnClose
            });

            return id;
        },

        clearNotifications: function (options) {
        },

        clearNotification: function (options) {
            if (options && options.id) {
                this.LE.vent.trigger("topBarNotificationController:removeNotification", {
                    id: options.id
                });
            }
        },

        getNotificationId: function () {
            this.notificationCounter++;

            return this.notificationCounter;
        },
        isValidOptions: function (options) {
            var isValid = AbstractAppender.prototype.isValidOptions.call(this, options);
            if (isValid) {
                if (!options.type && !CONST.TOP_BAR_NOTIFICATION_TYPE[options.type]) {
                    this.logger.error("TopBarNotification::isValidOptions - options.type is missing or invalid (type is required and must be type of CONST.TOP_BAR_NOTIFICATION_TYPE)");
                    this.logger.graph({name:"framework:TopBarNotification:isValidOptions:error"});
                    isValid = false;
                }
                if (options.contentOptions) {
                    if (!options.contentOptions.text) {
                        this.logger.error("TopBarNotification::isValidOptions - options.contentOptions.text is missing (options.contentOptions.text is required for notification with content)");
                        this.logger.graph({name:"framework:TopBarNotification:isValidOptions:error"});
                        isValid = false;
                    }
                    if (options.contentOptions.buttonCaption && !(options.contentOptions.buttonCallback && !_.isFunction(options.contentOptions.buttonCallback))) {
                        this.logger.error("TopBarNotification::isValidOptions - options.contentOptions.buttonCallback is missing or not a function (options.contentOptions.buttonCallback is required if options.buttonCaption)");
                        this.logger.graph({name:"framework:TopBarNotification:isValidOptions:error"});
                        isValid = false;
                    }
                    if (options.contentOptions.buttonCallback) {
                        if (!options.contentOptions.buttonCaption) {
                            this.logger.error("TopBarNotification::isValidOptions - options.contentOptions.buttonCaption is missing (options.contentOptions.buttonCaption is required if options.contentOptions.buttonCallback)");
                            this.logger.graph({name:"framework:TopBarNotification:isValidOptions:error"});
                            isValid = false;
                        }
                        if (!_.isFunction(options.contentOptions.buttonCallback)) {
                            this.logger.error("TopBarNotification::isValidOptions - options.contentOptions.buttonCallback must be a function)");
                            this.logger.graph({name:"framework:TopBarNotification:isValidOptions:error"});
                            isValid = false;
                        }
                    }
                }
                if (options.viewOptions && !options.viewOptions.getContentViewCallBack) {
                    this.logger.error("TopBarNotification::isValidOptions - options.viewOptions.getContentViewCallBack is required)");
                    this.logger.graph({name:"framework:TopBarNotification:isValidOptions:error"});
                    isValid = false;
                }
                if (options.onShow && !_.isFunction(options.onShow)) {
                    this.logger.error("TopBarNotification::isValidOptions - options.onShow must be a function)");
                    this.logger.graph({name:"framework:TopBarNotification:isValidOptions:error"});
                    isValid = false;
                }
                if (options.onClose && !_.isFunction(options.onClose)) {
                    this.logger.error("TopBarNotification::isValidOptions - options.onClose must be a function)");
                    this.logger.graph({name:"framework:TopBarNotification:isValidOptions:error"});
                    isValid = false;
                }
            }
            return isValid;
        },
        _setSettings: function (options) {
            options.settings = options.settings || {};
            this.SETTINGS.MAX_NOTIFICATIONS = (options.settings.maxNotifications && _.isNumber(options.settings.maxNotifications)) ? options.settings.maxNotifications : this.SETTINGS.MAX_NOTIFICATIONS;
            this.SETTINGS.DISPLAY_WHEN_EMPTY = options.settings.displayWhenEmpy || this.SETTINGS.DISPLAY_WHEN_EMPTY;
        },
        _setTopBarNotificationController: function () {
            this.topBarNotificationController = new TopBarNotificationController({application: this.LE});
        }

    });



    return TopBarNotification;

});

